// extracted by mini-css-extract-plugin
export default {"container":"backoffice_container__QJQnw","sidebar":"backoffice_sidebar__BTm8G","active":"backoffice_active__XrLTn","content":"backoffice_content__5yLck"};